import moment from "moment";
import CustomerIdCell from "src/utils/customerIdCell"
import { badge } from "src/utils/statusColorsCode";
const operationIcons = {
    "Fee": "fee-icon",
    "Freeze": "freez-icon",
    "UnFreeze": "unfreez-icon",
    "Unfreeze": "unfreez-icon",
    "SetPin": "setpin-icon",
    "BindCard": "bindcard-icon",
    "Card Creation": "card-creation-icon",
    "Cancelled": "card-cancelled-icon",
    "Top-up": "topup-icon",
    "Refund": "refund-icon",
    "Consumption": "consumption-icon",
    "First Recharge": "firstrechanrge-icon"
};
export const CardIdHandler = ({ data, handledetails, copiedId, handleCopy }) => {
    return (
        <td onClick={handledetails(true, data)} className='text-link'>
            <CustomerIdCell customerId={data?.cardId} linkText={"link"} copied={copiedId} handleCopy={handleCopy} />
        </td>
    )
}
export const OperationTypeHandler = ({ data }) => {
    const operationType = data?.operationType;
    const iconClass = operationIcons[operationType] || "default-icon";
    return (
        <td>
            <span className={`icon ${iconClass} mr-2`}></span>
            <span>{operationType}</span>
        </td>
    );
}
export const OperationTimeHandler = ({ data }) => {
    return (
        <td>
            <div>
                {data?.operationTime ? <> {moment.utc(data?.operationTime).local().format("DD/MM/YYYY hh:mm:ss A")}</> : data?.operationTime}
            </div>
        </td>
    );
}
export const StateHandler = ({ data }) => {
    return (
        <td> <span className={`status-badge ${badge[data?.state?.toLowerCase()] || "bg-green"}`}>{data?.state}</span></td>
    );
}